var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/mic",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,10 C18.553,10 19,10.448 19,11 C19,14.52 16.387,17.432 13,17.92 L13,17.92 L13,20 L15.105,20 C15.598,20 16,20.402 16,20.895 L16,20.895 L16,21.105 C16,21.598 15.598,22 15.105,22 L15.105,22 L8.895,22 C8.402,22 8,21.598 8,21.105 L8,21.105 L8,20.895 C8,20.402 8.402,20 8.895,20 L8.895,20 L11,20 L11,17.92 C7.613,17.432 5,14.52 5,11 C5,10.448 5.447,10 6,10 C6.553,10 7,10.448 7,11 C7,13.757 9.243,16 12,16 C14.757,16 17,13.757 17,11 C17,10.448 17.447,10 18,10 Z M12,2 C14.206,2 16,3.794 16,6 L16,6 L16,11 C16,13.206 14.206,15 12,15 C9.794,15 8,13.206 8,11 L8,11 L8,6 C8,3.794 9.794,2 12,2 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.8f45bbe4.svg";
export { ForwardRef as ReactComponent };